import React, {useRef, useState} from 'react';
import Keyboard from 'react-simple-keyboard';
import 'react-simple-keyboard/build/css/index.css';
import TextareaAutosize from '@mui/material/TextareaAutosize';

import ExerciseAppBar from './ExerciseAppBar';
import SecondaryAppBar from './SecondaryAppBar';
import Card from './Card';

import styles from '../css/Writing.module.css';
import '../css/Keyboard.css';

export default function Writing({exercise, mode}) {
  const [text, setText] = useState('');
  const [keyboardLayout, setKeyboardLayout] = useState('default');
  const [isCardVisible, setIsCardVisible] = useState(false);
  const keyboard = useRef();

  function handleClear() {
    setText('');
    setIsCardVisible(false);
  }

  function handleChange(event) {
    setText(event.target.value);
    keyboard.current.setInput(event.target.value);
  }

  function handleKeyboardChange(input) {
    setText(input);
  }

  const handleShift = () => {
    const newLayoutName = keyboardLayout === 'default' ? 'shift' : 'default';
    setKeyboardLayout(newLayoutName);
  };

  function handleKeyboardKeyPress(button) {
    if (button === '{shift}' || button === '{lock}') handleShift();
  }

  function handleClickCard() {
    setIsCardVisible(!isCardVisible);
  }

  return (
    <>
      {mode === 'EXERCISE' && <ExerciseAppBar exercise={exercise} />}
      <SecondaryAppBar onClickClear={handleClear} onClickCard={handleClickCard} />

      <div className={styles.container}>
        <TextareaAutosize
          className={styles.textarea}
          minRows={8}
          placeholder="Begin typing your sentence..."
          value={text}
          onChange={handleChange}
        />
        <div className={styles.keyboard}>
          <Keyboard
            keyboardRef={(r) => (keyboard.current = r)}
            layoutName={keyboardLayout}
            onChange={handleKeyboardChange}
            onKeyPress={handleKeyboardKeyPress}
            physicalKeyboardHighlight
            physicalKeyboardHighlightBgColor={getComputedStyle(document.documentElement).getPropertyValue(
              '--primary-500',
            )}
            newLineOnEnter
          />
        </div>
      </div>
      {isCardVisible && <Card onClose={() => setIsCardVisible(false)} />}
    </>
  );
}
